import { cookiesStorage } from '$utils/services/cookiesStorage'

export const handleCookiesLaw = (cookieLawState: Boolean) => {
  return cookiesStorage.saveCookie('cookiesLaw', cookieLawState.toString())
}



// WEBPACK FOOTER //
// ./src/services/user/cookiesLaw/handleCookiesLaw.service.ts